// modules
import { createSelector } from 'reselect'

export const alertNotesReport$ = (state) => state.reports.alertNotesReport

export const alertNotesList$ = createSelector(
  alertNotesReport$,
  ({ alertNotesList = [] }) => alertNotesList
)
